var tooltip;

export const CustomTooltip = ({ active, payload }) => {
  if (!active || !tooltip) return null;
  for (const bar of payload)
    if (bar.dataKey === tooltip)
      return (
        <div className="tooltipCustom">
          {bar.name}
          <br />
          {bar.value.toFixed(2)}
        </div>
      );
  return null;
};